'use strict';

const fetchDeprecationManifest = () => window.fetch(`/assets/deprecationManifest.json?t=${new Date().getTime()}`).then(response => response.json());

const oldEnvRegex = {
    staging: /dash-qa(-\d)?\.adjust/,
    demo: /dash-demo(-\d)?\.adjust/,
    prod: /dash\.adjust/,
};
const getSuiteHost = () => {
    var _a, _b, _c;
    const { host } = window.location;
    if (oldEnvRegex.staging.test(host)) {
        const qaNumber = ((_a = host.match(oldEnvRegex.staging)) === null || _a === void 0 ? void 0 : _a[1]) || '-1';
        return `https://staging${qaNumber}.suite.adjust.com`;
    }
    else if (oldEnvRegex.demo.test(host)) {
        const demoNumber = ((_b = host.match(oldEnvRegex.demo)) === null || _b === void 0 ? void 0 : _b[1]) || '-1';
        return `https://demo${demoNumber}.suite.adjust.com`;
    }
    else if (oldEnvRegex.prod.test(host)) {
        return 'https://suite.adjust.com';
    }
    // For local development
    if (host.includes('local.adjust.com')) {
        const qaNumber = ((_c = (process.env.NODE_ENV || 'qa-1').match(/\d+/)) === null || _c === void 0 ? void 0 : _c[0]) || '1';
        return `https://staging-${qaNumber}.suite.adjust.com`;
    }
    return `https://${host}`;
};
const classicRedirectToSuite = (to) => {
    const suiteDomain = getSuiteHost();
    const toEncoded = encodeURIComponent(to);
    return `${suiteDomain}/classic-redirect?from=generic_dash&to=${toEncoded}`;
};

function debugLog(...args) {
    if (window.localStorage.getItem('deprecationDebug') === 'true') {
        console.log('[Deprecation]', ...args);
    }
}
const _isDeprecationEnabled = (currentAccount, currentUser, options) => {
    if (!(options === null || options === void 0 ? void 0 : options.isPublicRoute) && (!currentAccount || !currentUser)) {
        // If it's not a public route and we don't have an account or user, we should not redirect.
        return false;
    }
    else if ((options === null || options === void 0 ? void 0 : options.isPublicRoute) && !currentAccount && !currentUser) {
        // If it's a public route and we don't have an account or user, we should redirect.
        return true;
    }
    if (options) {
        let isAccountExcluded = false;
        if (options.excludedAccounts && (currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.id)) {
            isAccountExcluded = options.excludedAccounts.includes(Number(currentAccount.id));
        }
        let isUserExcluded = false;
        if (options.excludedUsers && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id)) {
            isUserExcluded = options.excludedUsers.includes(Number(currentUser.id));
        }
        let isUserRoleExcluded = false;
        if (options.excludedUserRoles && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.role)) {
            isUserRoleExcluded =
                options.excludedUserRoles.includes(currentUser.role) ||
                    (options.excludedUserRoles.includes('super_admin') &&
                        currentUser.role === 'admin' &&
                        Boolean(currentUser.super_admin || currentUser.superAdmin));
        }
        if (isAccountExcluded || isUserExcluded || isUserRoleExcluded) {
            return false;
        }
    }
    return true;
};
const _findMatchingDeprecation = (toUrl, manifest) => {
    const deprecation = manifest === null || manifest === void 0 ? void 0 : manifest.deprecations.find(([fromDashPattern]) => {
        if (fromDashPattern.includes('*')) {
            const regex = new RegExp(fromDashPattern.replace('*', '.*'));
            return regex.test(toUrl);
        }
        else {
            return fromDashPattern === toUrl;
        }
    });
    if (deprecation) {
        debugLog(`MATCH: deprecation: ${JSON.stringify(deprecation)}`);
    }
    return deprecation || [];
};
const _constructSuiteUrl = (toSuitePattern, params) => {
    return Object.entries(params).reduce((acc, [key, value]) => acc.replace(`:${key}`, value), toSuitePattern);
};
const _redirectToSuite = to => {
    debugLog(`Redirecting to suite: ${to}`);
    window.location.replace(classicRedirectToSuite(to));
};
const checkUrlForDeprecation = ({ toUrl, currentAccount, currentUser, manifest, params, }) => {
    const [, toSuitePattern, deprecationOptions] = _findMatchingDeprecation(toUrl, manifest);
    if (toSuitePattern) {
        const isDeprecationEnabledGlobally = _isDeprecationEnabled(currentAccount, currentUser, manifest);
        const isDeprecationEnabledLocally = deprecationOptions
            ? _isDeprecationEnabled(currentAccount, currentUser, deprecationOptions)
            : true;
        let isDeprecationEnabled = false;
        if (isDeprecationEnabledLocally) {
            if (deprecationOptions === null || deprecationOptions === void 0 ? void 0 : deprecationOptions.isPublicRoute) {
                // If it's a public route, we should always redirect.
                isDeprecationEnabled = true;
            }
            else {
                // If it's not a public route, we should redirect only if deprecation is also enabled globally.
                isDeprecationEnabled = isDeprecationEnabledGlobally;
            }
        }
        debugLog('checkUrlForDeprecation', JSON.stringify({
            isDeprecationEnabled,
            isDeprecationEnabledLocally,
            isDeprecationEnabledGlobally,
            isPublicRoute: deprecationOptions === null || deprecationOptions === void 0 ? void 0 : deprecationOptions.isPublicRoute,
        }));
        if (!isDeprecationEnabled) {
            return;
        }
        const suiteUrl = _constructSuiteUrl(toSuitePattern, params);
        _redirectToSuite(suiteUrl);
    }
};

exports.checkUrlForDeprecation = checkUrlForDeprecation;
exports.debugLog = debugLog;
exports.fetchDeprecationManifest = fetchDeprecationManifest;
